// extracted by mini-css-extract-plugin
module.exports = {"error":"FormError_error__gHDlo"};